import { useEffect } from "react";
import { useDispatch } from "react-redux";
//import { selectTxReportedError, selectTxReportedLoading } from "../../redux/selectors/transactionSelectors";
import { reportTransaction } from "../../redux/actions/transaction";
import { message } from "antd";


const AuthorizeRefund = ({ onClose, open, txRef }) => {
    const dispatch = useDispatch();
    //const isLoading = useSelector(selectTxReportedLoading);
    //const error = useSelector(selectTxReportedError);

    useEffect(() => {
        if (open) {
            message.loading("Authorizing refund... Please wait.");

            dispatch(reportTransaction(txRef)).then(res => {
                message.success(res?.message ?? "Refund authorized successfully.");
            }).catch(err => {
                message.error(err?.message ?? err);
            });

            if (typeof onClose === 'function') {
                onClose();
            }
        }
    }, [dispatch, onClose, open, txRef]);


    return (<></>);
}

export default AuthorizeRefund;
